import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";

import Despacho from "@/pages/modules/Despacho";
import Clientes from "@/pages/modules/Clientes";
import ClienteDetalle from "@/pages/modules/clientes/ClienteDetalle";
import Procesos from "@/pages/modules/Procesos";
import Notarial from "@/pages/modules/Notarial";
import Solicitudes from "@/pages/modules/Solicitudes";
import Mensajes from "@/pages/modules/Mensajes";
import Formularios from "@/pages/modules/Formularios";
import FormularioPublico from "@/pages/FormularioPublico";
import Cobros from "@/pages/modules/Cobros";
import Archivo from "@/pages/modules/Archivo";
import Pagos from "@/pages/modules/Pagos";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/f/:token" element={<FormularioPublico />} />

            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/despacho" element={<Despacho />} />
              <Route path="/clientes" element={<Clientes />} />
              <Route path="/clientes/:id" element={<ClienteDetalle />} />
              <Route path="/procesos" element={<Procesos />} />
              <Route path="/notarial" element={<Notarial />} />
              <Route path="/solicitudes" element={<Solicitudes />} />
              <Route path="/mensajes" element={<Mensajes />} />
              <Route path="/formularios" element={<Formularios />} />
              <Route path="/cobros" element={<Cobros />} />
              <Route path="/archivo" element={<Archivo />} />
              <Route path="/pagos" element={<Pagos />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
